import type { AriaDatapointType, DatapointStatus } from 'owa-analytics-types';
import { getAnalyticsAddon } from 'owa-analytics-addons';
import { resolveDatapointTimeGate } from 'owa-analytics-core/lib/utils/datapointTimeGate';

export function cacheDatapointForDiagnostics(
    datapoint: AriaDatapointType,
    admitted = false,
    status?: DatapointStatus
): void {
    if (!admitted && resolveDatapointTimeGate(datapoint.getOptions() ?? {}) !== undefined) {
        return;
    }
    const addon = getAnalyticsAddon('DatapointsCachePush');
    if (addon?.isRegistered) {
        const properties = datapoint.getAllProperties();
        addon.executeWhenReady(
            datapoint.getEventName(),
            status ?? properties.Status,
            properties.E2ETimeElapsed
        );
    }
}
